export const DEFAULT_SORT_DIRECTION = 'asc';
export const DEFAULT_SORT_FIELD = 'name';
